import React, { useState } from "react";

import "./App.css";

import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import "firebase/functions";

import axios from "axios";

import {BrowserRouter as Router, Switch, Route}  from 'react-router-dom';

import Login from "./pages/Login";
import Home from './pages/Home';
import StartPage from './pages/StartPage';
import SignUp from './pages/SignUp';
import NavBar from './pages/NavBar';
import Profile from './pages/Profile';

export const app = firebase.initializeApp({
  apiKey: "AIzaSyAi0uBLS4ka91VVboG7aOg8UYG7b0Jgy9M",
  authDomain: "distant-medicus.firebaseapp.com",
  databaseURL: "https://distant-medicus.firebaseio.com",
  projectId: "distant-medicus",
  storageBucket: "distant-medicus.appspot.com",
  messagingSenderId: "453787845546",
  appId: "1:453787845546:web:9f80095efa3235a0eea1d3",
  measurementId: "G-WPSWTGP7Q8",
});

axios.defaults.baseURL =
  "https://europe-west3-distant-medicus.cloudfunctions.net/api";

export const auth = firebase.auth();


function App() {
  const [user, setUser] = useState(null);
  const [claim, setClaim] = useState(null);

  firebase.auth().onAuthStateChanged((user) => {
    if (user) {
      user.getIdTokenResult().then((idTokenResult) => {
        // console.log(idTokenResult.claims.doctor);
        user.doctor = idTokenResult.claims.doctor;
        user.doctor ? setClaim("doctor") : setClaim("patient");
        localStorage.setItem("claim", claim);
        localStorage.setItem("user", user.uid);
        // if (idTokenResult.claims.doctor) {
        //   setClaim("A Doctor");
        // }
      });
 
      setUser(user);
    } else {
      // User is signed out
      setClaim("offline");
      localStorage.setItem("claim", claim);
      localStorage.setItem("user", null);
    }
  });

  return (
    <Router>
    <div className="App">
      <NavBar/>
      <Switch>
        <Route path='/' exact component={StartPage}/>
        <Route path='/login' component={Login} />
        <Route path='/signup' component={SignUp} />
        <Route path='/home' component={Home}/>
        <Route exact path='/users/:uid' component={Profile}/>
      </Switch>
    </div>
    </Router>
  );
}

export default App;
